var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckVariant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4,3.2l0,0.4C10,6.2,8.1,9.3,6.8,12c-0.8,0.5-1.3,1.2-1.7,0.4c-0.4-1.1-1.3-3.2-2.5-3.6c0.5-0.6,1-0.8,1.6-0.7C5,8.3,5.7,9.8,6,10.5C7.6,7.8,10.5,4.7,13.4,3.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckVariant);
export default __webpack_public_path__ + "static/media/check-variant.a3164c1082dad72aa9b335afe6829392.svg";
export { ForwardRef as ReactComponent };